/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Customer_Contact_TitleInputs */

const en_ticket_customer_contact_title = /** @type {(inputs: Ticket_Customer_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer & Contact`)
};

const ja_ticket_customer_contact_title = /** @type {(inputs: Ticket_Customer_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`顧客と連絡先`)
};

const fr_ticket_customer_contact_title = /** @type {(inputs: Ticket_Customer_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client et contact`)
};

const de_ticket_customer_contact_title = /** @type {(inputs: Ticket_Customer_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunde & Kontakt`)
};

/**
* | output |
* | --- |
* | "Customer & Contact" |
*
* @param {Ticket_Customer_Contact_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_customer_contact_title = /** @type {((inputs?: Ticket_Customer_Contact_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Customer_Contact_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_customer_contact_title(inputs)
	if (locale === "ja") return ja_ticket_customer_contact_title(inputs)
	if (locale === "fr") return fr_ticket_customer_contact_title(inputs)
	return de_ticket_customer_contact_title(inputs)
});